import { Injectable, signal } from '@angular/core';
import { ConfigService } from './config.service';
import { RivalChatService } from './rival-chat.service';
import { ChatwootService } from './chatwoot.service';
import { UserModel } from '../models/user.model';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root'
})
export class ChatService {
  /**
   * this services decides which chat to use, based on configService & environments: ChatSystem
   * Rival brands: 'rival' chat + some (ex.lust/21grand) will also have chatwoot - needed for flipAPI
   * GP brands: 'chatwoot' or 'other'
   * 'other' means that we show the rival style chat component, but don't use any chat yet
   */

  public chatSystem = signal(this.configs.chatSystem);

  constructor(
    private configs: ConfigService,
    private rivalChatService: RivalChatService,
    private chatwootService: ChatwootService,
    private userService: UserService
  ) {
    if (this.chatSystem() === 'chatwoot') {
      this.chatwootService.loadChatwoot();
    }
  }

  initializeChat(user: UserModel, token?: string) {
    if (this.chatSystem() === 'rival') {
      const chatToken = token ?? localStorage.getItem('sessionToken') ?? undefined;
      this.rivalChatService.initialize(true, chatToken);
    } else if (this.chatSystem() === 'chatwoot') {
      this.chatwootService.setUser(user);
    }
  }

  logout() {
    if (this.chatSystem() === 'rival') {
      this.rivalChatService.toggleChat(false);
      this.rivalChatService.closeWebSocket();
    } else if (this.chatSystem() === 'chatwoot') {
      this.chatwootService.resetUser();
    }
  }

  handleChatFlip() {
    //shutdown current chat 
    this.logout();

    this.chatSystem.set(this.configs.chatSystem);

    //load chatwoot for the flip
    if (this.configs.chatSystem === 'chatwoot') {
      this.chatwootService.loadChatwoot();
    }

    //initialize new chat
    //the new chat system will be re-initialized by AuthService after it refetches the user profile from the new server
  }


  toggleChat(show: boolean): void {
    if (this.chatSystem() === 'other') {
      this.rivalChatService.toggleChat(show);
    }

    if (this.chatSystem() === 'rival') {
      this.rivalChatService.toggleChat(show);

      //workflow for guest user: opening/closing chat window means opening/closing chat ws connection
      if (!this.userService.user()) {
        if (show) {
          this.rivalChatService.initialize(true);
        } else {
          this.rivalChatService.closeWebSocket();
        }
      }
    } else if (this.chatSystem() === 'chatwoot') {
      this.chatwootService.toggleChatWindow(show);
    }
  }

  showOrHideChatButton(showBtn: boolean) {
    //false=hide, true=show the chat button/widget ex. on iframe pages
    if (this.configs.chatSystem === 'rival' || this.configs.chatSystem === 'other') {
      this.rivalChatService.toggleChatBtnShown(showBtn);
    } else {
      this.chatwootService.toggleBtn(showBtn);
    }
  }

}
